module.exports = __webpack_public_path__ + "c91f27c2bec9aafade906ee54f193152.svg";